export const sanitizePlainText = (val, maxLen) => {
  if (!val) return '';
  return String(val).substring(0, maxLen);
};

export const stripCoordString = (val, dec, max) => {
  if (!val) return '';
  return String(val).replace(/[^0-9.-]/g, '').substring(0, max);
};

export const clampLatLngString = (val, min, max) => {
  const num = parseFloat(val);
  if (isNaN(num)) return '';
  if (num < min) return String(min);
  if (num > max) return String(max);
  return String(num);
};

export const LAT_MIN = -90;
export const LAT_MAX = 90;
export const LNG_MIN = -180;
export const LNG_MAX = 180;
export const MAX_LAT_INPUT_LEN = 20;
export const MAX_LNG_INPUT_LEN = 20;
export const MAX_HEIGHT_INPUT_LEN = 10;
